import React, { useEffect, useState } from 'react'
import Styles from './styles.module.sass'
import MainLayout from 'newComponents/Layout/MainLayout'
import CreditoLayout from 'newComponents/Layout/CreaditoLayout'
import Notifications from 'newComponents/ModuleNotification'
import ModuleSaldos from 'newComponents/ModulesHome/ModuleSaldos'
import ModuleImportes from 'newComponents/ModulesHome/ModuleImportes'
import ModulePagos from 'newComponents/ModulesHome/ModulePagos'
import ModuleBanners from 'newComponents/ModulesHome/ModuleBanners'
import ModuleCard from 'newComponents/ModuleCard'

const Home = () => {

    const [ data, setData ] = useState()
    const [ message, setMesagge ] = useState()
    const [ udCard, setUdCard ] = useState()

    return(
        <MainLayout>
            <CreditoLayout setData={setData} udCard={udCard} setOtherUDcard={setUdCard} >

                <ModuleCard cardsService={data} setUdCard={setUdCard} clase="homeCard"/>

                {message &&
                    <Notifications type='warning' message={message} />
                }
                
                <h2 className={Styles?.contTitlePage}>Saldo</h2>
               
                <div className={Styles?.contHome}>
                    <ModuleSaldos data={data} />

                    <ModulePagos data={data} />

                    <ModuleImportes data={data} />
                    
                    <ModuleBanners />     
                </div>
            </CreditoLayout>
        </MainLayout>
    )
}

export default Home